export default __webpack_public_path__ + "static/media/BannerPressmedia.4e5efe63.png";